import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "core-integration/src/store";
import { logout } from "core-integration/src/store/player/thunks";

const Logout: React.FC = () => {
  const dispatch = useDispatch<ThunkDispatch>();

  useEffect(() => {
    const performLogout = async () => {
      try {
        await dispatch(logout());
        window.location.replace("/");
      } catch (e) {
        console.error(e);
      }
    };
    performLogout();
  }, [dispatch]);

  return <div />;
};

export default Logout;
